if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (context) => {
  const snippetContainer = context.classList.contains(
    '.sn_card_product',
  )
    ? context
    : context.closest('.sn_card_product');
  if (
    !snippetContainer
  )
  return;
  const wishlistButton = snippetContainer.querySelector('[data-wishlist-btn]');

  if (wishlistButton) {
    wishlistButton.addEventListener('click', async (e) => {
      e.preventDefault();
      wishlistButton.classList.add('loading');
      const variantID = wishlistButton?.dataset?.wishlistVariantId;
      const masterID = wishlistButton?.dataset?.wishlistProductId;
      const productURL = wishlistButton?.dataset?.wishlistProductUrl;
      const price = wishlistButton?.dataset?.wishlistPrice;
      const compareAtPrice = wishlistButton?.dataset?.wishlistCompareAtPrice;
      const imageSrc = wishlistButton?.dataset?.wishlistImage;
      const addText = wishlistButton.querySelector('.text-wishlist__add');
      const removeText = wishlistButton.querySelector('.text-wishlist__remove');

      if (wishlistButton?.dataset?.wishlistStatus === 'active') {
        await window.dAgency.deleteFromWishlist({ variantID, masterID, productURL });
        wishlistButton.dataset.wishlistStatus = 'inactive';
        addText.classList.remove('hidden');
        removeText.classList.add('hidden');
      } else {
        await window.dAgency.addToWishlist({
          variantID,
          masterID,
          productURL,
          compareAtPrice,
          price,
          imageSrc
        });
        wishlistButton.dataset.wishlistStatus = 'active';
        removeText.classList.remove('hidden');
        addText.classList.add('hidden');
      }
      wishlistButton.classList.remove('loading');
    });
  }
};

window.dAgency.execOnLoad(window.dAgency.initProductTile, '.sn_card_product');
